import { TimeseriesValues, TimestampData } from '../../local_modules/voy-timeseries-chart/src/echartUtils';
import { LegData, LegInfo, CurrentLeg, ParameterValue, RemainingDataToPilot } from '../models/vessel-performance-model';

export class PerformanceUtils {
    /** Skip plotting speeds above this (knots) — matches Fleet AIS sanity rule. */
    static readonly MAX_AIS_SPEED_KNOTS = 30;

    static ZeroLegData() : LegData {
        return {
            title: "",
            unit: "",
            current: 0.0,
            nextLeg: 0.0,
            simulated: { value: 0.0 },
            max: 0.0
        }
    }
    
    static ZeroLegInfo() : LegInfo {
        return {
            nextLegWaypointDetails: "",
            etaBasedOnCurrentSpeed: null,
            distance: 0.0,
            distanceToPilot: 0.0,
            timeToPilotTs: 0,
            timeToPilotEta: 0,
            pilotTimestamp: null,
            avgSpeedToPilotEta: 0.0
        }
    }
    
    static ZeroCurrentLeg() : CurrentLeg {
        return {
            MEPower: { title: "ME POWER", unit: "KW", current: null, nextLeg: null, simulated: null },
            RPM: { title: "ME RPM", unit: "RPM", current: null, nextLeg: null, simulated: null },
            SOG: { title: "SOG", unit: "Kt", current: null, nextLeg: null, simulated: null },
            STW: { title: "STW", unit: "Kt", current: null, nextLeg: null, simulated: null },
            RollAngle: { title: "Predicted Roll Angle", unit: "Degrees", nextLeg: null, simulated: null },
            info: PerformanceUtils.ZeroLegInfo()
        };
    }

    static paramValuesToTimeseries(values: ParameterValue[]): TimeseriesValues
    {
        const result: TimeseriesValues = {
            timestamps: [],
            values: [],
        };

        if (values[0].lower !== undefined && values[0].upper !== undefined)
        {
            result.lower = [];
            result.upper = [];
        }

        for (const value of values)
        {
            result.timestamps.push(value.timestamp);
            result.values.push(value.value);
            if (result.lower && result.upper)
            {
                result.lower.push(value.lower!);
                result.upper.push(value.upper!);
            }
        }

        return result;
    }

    static addConstantToTimeseries(timestamps: TimestampData[], constant: number): TimeseriesValues
    {
        const result: TimeseriesValues = {
            timestamps: [],
            values: [],
        };

        for (const timestamp of timestamps)
        {
            result.timestamps.push(timestamp.timestamp);
            result.values.push(constant);
        }

        return result;
    }

    static ZeroRemainingLegData() : RemainingDataToPilot {
        return {
            distanceToPilot: 0,
            timeToPilotEta: 0,
            avgSpeedToPilotEta: 0,
        }
    }
}